module.exports = __webpack_public_path__ + "img/icon-location-90662b52.svg";